<template>
  <div class="info">
    <div class="info-left">
      <div>
        <div class="info-left-flex" @click="$emit('showBottleUserInfo', bottleInfo)">
          <img src="@/assets/images/ziyuan143.png" alt="" /> 气瓶二维码：
          {{ bottleId }}
        </div>
      </div>
      <div>
        
        <div class="info-left-flex" @click="$emit('showBottleUserInfo', bottleInfo)">
          <img src="@/assets/images/scan-code.png" alt="" /> 出产编号：
          {{ bottleInfo.can_release_no }}
        </div>
      </div>
      <div style="display: block">
        <div class="info-left-flex">
          <img src="@/assets/images/liucheng0.png" alt="" />上次流程：
         <!-- {{ bottleInfo.top_record == "配送站" ? "门店" : bottleInfo.top_record }} -->
         {{bottleInfo.step_name}}
        </div>
        <div style="padding-left: 8.4vw;">
          <div style="white-space: pre-line;">{{ process }}</div>
          <div>{{ bottleInfo.process_time }}</div>
        </div>
      </div>
    </div>
    <div class="info-right">
      <div class="info-right-bg">
        <div :style="bottleInfo.recovery_weight > 10 && 'font-size: 4.6vw;'">
          {{
            bottleInfo.recovery_weight
              ? bottleInfo.recovery_weight + "KG"
              : "--"
          }}
        </div>
      </div>
      <div class="info-right-text">上次安检余量</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bottleInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    bottleId() {
      return this.$store.state.bottleId;
    },
    process(){
      return (this.bottleInfo.process ? this.bottleInfo.process.replace('\\n', '\n') : this.bottleInfo.process)
    }
  },
};
</script>

<style lang="scss" scoped>
.info {
  line-height: 6vw;
  height: 40.6vw;
  background-image: url("../../assets/images/k-bg.png");
  background-size: 100% 100%;
  margin: 1.9vw 2.6vw;
  display: flex;
  .info-left {
    width: 74vw;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 4vw;
    padding: 3.8vw;
    color: white;
    box-sizing: border-box;
    & > div {
      display: flex;
      flex-basis: 100%;
      & > div > div:nth-child(3) {
        font-size: 3.3vw;
        line-height: 3vw;
        font-family: Microsoft YaHei;
      }
    }
    .info-left-flex {
      display: flex;
      align-items: center;
      height: fit-content;
    }
    img {
      width: 6.4vw;
      height: 6.4vw;
      margin-right: 2vw;
    }
  }
  .info-right {
    font-size: 2.5vw;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 5vw;
    text-align: center;
    .info-right-bg {
      background-image: url("../../assets/images/bol.png");
      height: 29vw;
      width: 29vw;
      background-size: cover;
      margin: 0 auto;
      margin-top: 2.8vw;
      margin-right: 3.3vw;
      display: flex;
      align-items: center;
      justify-content: center;
      div {
        font-size: 5.6vw;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #f13a24;
      }
    }
    .info-right-text {
      line-height: 6.7vw;
      background: white;
      color: #2e8dff;
      font-size: 4.2vw;
      margin-right: 3.3vw;
      margin-top: .7vw;
      border-radius: 1px 1px 2vw 1px;
    }
  }
}
</style>